import { render } from "./QRDialogContent.vue?vue&type=template&id=24b1621c&scoped=true"
import script from "./QRDialogContent.vue?vue&type=script&lang=js"
export * from "./QRDialogContent.vue?vue&type=script&lang=js"

import "./QRDialogContent.vue?vue&type=style&index=0&id=24b1621c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b1621c"]])

export default __exports__